import React, { useState } from "react";
import { useThemeColors } from "../../Context/Theme";
import {
  Box,
  CircularProgress,
  Divider,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect } from "react";

const NotificationSidebar = ({
  setSelectedNotification,
  selectedNotification,
  data,
  isLoading,
}) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  useEffect(() => {
    setSelectedNotification(data[0]);
  }, [data]);

  
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    linkColor,
    backgroundColor,
    logo,
    fontFamily,
    fontWeight,
  } = useThemeColors();

  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
          height: "90%",
          maxHeight: "100%",
          overflowY: "auto",
          scrollbarWidth: "none",
          maxWidth: "100%",
          backgroundColor: "white",
          borderRadius: "21px",
          paddingBottom: "20px",
          paddingTop: "20px",
          boxShadow: "0px 4px 19px 0px #D6D6D640",
          "@media (max-width: 600px)": {
            maxWidth: "100%",
            padding: "10px",
            fontFamily: fontFamily || "poppins",
          },
        }}
      >
        <List
          component="nav"
          sx={{ paddingX: "10px" }}
          aria-label="main mailbox folders"
          style={{ height: "100%", width: "100%" }}
        >
          {isLoading ? (
            <Box
              width={"100%"}
              height={"100%"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <CircularProgress />
            </Box>
          ) : (
            data?.map((item, index) => (
              <>
                <ListItem
                  onClick={() => {
                    setSelectedNotification(item)
                    toggleExpand(index);
                  }}
                  sx={{
                    cursor: "pointer",
                    padding: "14px 10px",
                    gap: "10px",
                    backgroundColor:
                      selectedNotification?.notification_id ===
                      item?.notification_id
                        ? "#e7f5ff"
                        : "",
                    borderRight:
                      selectedNotification?.notification_id ===
                      item?.notification_id
                        ? `2px solid ${primaryColor}`
                        : "",
                    "&:hover": {
                      backgroundColor: "#e7f5ff",
                    },
                  }}
                  selected={index === 0}
                  key={index}
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      "@media (max-width: 600px)": {
                        width: "100%",
                      },
                    }}
                  >
                      <Stack
                        direction="row"
                        justifyContent={"space-between"}
                        alignContent={"center"}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: "600",
                            textAlign: "left",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            "@media (max-width: 600px)": {
                              width: "100%",
                            },
                            fontFamily
                          }}
                        >
                          {item?.heading}
                        </Typography>
                        <Typography sx={{ fontSize: "12px", color: "#565656" }}>
                          {new Date(item?.notification_date).toLocaleDateString()}
                        </Typography>
                      </Stack>
                   
                    <Stack direction="row">
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#565656",
                        textAlign: "left",
                        lineHeight: "1.2",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: expandedIndex === index ? "normal" : "nowrap",
                        width: "100%",
                        "@media (max-width: 600px)": {
                          width: "100%",
                        },
                        fontFamily
                      }}
                    >
                      {item?.description}
                      {expandedIndex === index && <Typography style={{ fontSize: "14px", color: "#0F7AC0", cursor: "pointer", "& :hover": {
                          textDecoration: "underline",
                        }, fontFamily }} onClick={() => toggleExpand(index)}>see less</Typography>}
                    </Typography>
                    {expandedIndex !== index && <Typography
                      sx={{ fontSize: "12px", color: "#0F7AC0", cursor: "pointer", width: "6%", 
                        "& :hover": {
                          textDecoration: "underline",
                        },
                        fontFamily
                       }}
                      onClick={() => toggleExpand(index)}
                    >
                      see more
                    </Typography>}
                    </Stack>
                  </Box>
                </ListItem>
                {index !== data?.length - 1 && (
                  <Divider
                    key={`divider-${index}`}
                    sx={{
                      width: "100%",
                      height: "1px",
                      border: "0.5px solid #D9D9D9",
                    }}
                  />
                )}
              </>
            ))
          )}
        </List>
      </Box>
    </React.Fragment>
  );
};

export default NotificationSidebar;
